import { isError, isNumber, isObject } from "es-toolkit/compat";

interface HttpError {
  response: {
    status: number;
  };
}

const isHttpError = (error: unknown): error is HttpError =>
  isError(error) &&
  "response" in error &&
  isObject(error.response) &&
  "status" in error.response &&
  isNumber(error.response.status);

export default isHttpError;
